/* eslint-disable no-undef */
if ($('#map').length) {
  ymaps.ready(function () {
    var myMap = new ymaps.Map('map', {
      center: [55.702830, 37.355722],
      zoom: 15,
      controls: ['zoomControl', 'typeSelector', 'fullscreenControl']
    });

    myMap.behaviors.disable('scrollZoom');

    let myPlacemark1 = new ymaps.Placemark(myMap.getCenter(), {}, {
      iconLayout: 'default#image',
      iconImageHref: $('#map').data('icon'),
      iconImageSize: [60, 91],
      iconImageOffset: [-31, -76],
    });

    myMap.geoObjects.add(myPlacemark1);
  });
}